import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useRef, useState } from 'react';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Box from '@mui/material/Box';
import { SubmitButton } from './SubmitButton.js';

const FileInput = ({
  color = 'primary',
  title,
  name = '',
  onChange,
  disabled = false,
  children,
  formik: {
    values,
    handleChange
  },
  sx = {},
  ...props
}) => {
  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState('');
  const [error, setError] = useState(null);
  const clickFileUploadButton = async () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    sx: {
      width: '100%',
      ...sx
    }
  }, props), /*#__PURE__*/React.createElement(SubmitButton, {
    color: color,
    disabled: isLoading,
    onClick: clickFileUploadButton,
    variant: "outlined",
    sx: {
      textTransform: 'none'
    }
  }, /*#__PURE__*/React.createElement(UploadFileIcon, null), file ? `選択中: ${file}` : error || title || 'ファイルを選択'), /*#__PURE__*/React.createElement("input", {
    onChange: async e => {
      setError(null);
      setIsLoading(true);
      try {
        if (handleChange) await handleChange(e);
        if (onChange) await onChange(e);
        setFile(e.target.value);
      } catch (error) {
        console.error('Failed to upload file', error);
        setError('ファイルの読み込みに失敗しました');
      }
      setIsLoading(false);
    },
    id: name,
    disabled: disabled,
    name: name,
    value: values[name],
    hidden: true,
    ref: inputRef,
    type: "file"
  }), children);
};

export { FileInput };
